import { decisionFromScore } from "@/lib/scoring";

const glow = {
  fonce: "shadow-[0_0_60px_-10px_#00E676]",
  investis: "shadow-[0_0_60px_-10px_#FFCC00]",
  ignore: "shadow-[0_0_60px_-10px_#FF3B30]",
};
const color = {
  fonce: "#00E676",
  investis: "#FFCC00",
  ignore: "#FF3B30",
};

export default function ScoreDial({ score, size = 200 }) {
  const d = decisionFromScore(score);
  const c = color[d.color];
  const stroke = 6;
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const off = circ - (score / 100) * circ;
  return (
    <div
      className={`relative inline-flex items-center justify-center rounded-full ${glow[d.color]}`}
      style={{ width: size, height: size }}
      data-testid="score-dial"
    >
      <svg width={size} height={size} className="rotate-[-90deg]">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#222" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={c}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={circ}
          strokeDashoffset={off}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 800ms ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-mono-num font-bold" style={{ color: c, fontSize: size * 0.32 }}>
          {score}
        </div>
        <div className="text-[10px] uppercase tracking-widest text-muted-2 mt-1">sur 100</div>
      </div>
    </div>
  );
}
